module.exports = __webpack_public_path__ + "img/googe play.a4cc2c09.jpeg";